import { Component, Input, OnChanges } from '@angular/core';
import { ImpagoEnviado } from '../../inicio.service';
import { formatShort, formatMoney } from '../../shared/format';

@Component({
  selector: 'app-saldo-cobrar',
  templateUrl: './saldo-cobrar.component.html',
  styleUrls: ['./saldo-cobrar.component.scss']
})
export class SaldoCobrarComponent implements OnChanges {
  // Pedidos entregados aun sin cobrar.
  @Input() impagos: ImpagoEnviado[] = [];

  totalPorCobrar = 0;
  totalKg = 0;
  cantidad = 0;

  expandido = false;

  formatShort = formatShort;
  formatMoney = formatMoney;

  ngOnChanges() {
    this.cantidad = this.impagos.length;
    this.totalPorCobrar = this.impagos.reduce((s, o) => s + (o.total || 0), 0);
    this.totalKg = this.impagos.reduce((s, o) => s + (o.totalKg || 0), 0);
  }
}
